import React from 'react';
import './Header.scss';

const Header = props => {
  const { title = '', onMouseEnter, onMouseLeave, content } = props;

  return (
    <div className="header" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <div className="title">{title}</div>
      <div className="header-content">{content}</div>
    </div>
  );
};

export default Header;
